<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form @submit="EditPmm" :validation-schema="PmmSchema">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="home-tab" data-bs-toggle="tab"
              data-bs-target="#home-tab-pane" type="button" role="tab"
              aria-controls="home-tab-pane" aria-selected="true">
              Information générale
            </button>
          </li>
        </ul>

        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active p-10" id="home-tab-pane" role="tabpanel" tabindex="0">
            <div class="row">

              <!-- Organe -->
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Organes <span class="text-danger">*</span>
                  </label>
                  <Field name="organes" v-slot="{ field }">
                    <Multiselect
                      :options="organesOptions" :searchable="true" :multiple="false"
                      track-by="value" label="label"
                      v-model="formData.organe" v-bind="field"
                      placeholder="Sélectionner l'organe"
                      @change="onOrganeChange"
                    />
                  </Field>
                  <ErrorMessage name="organes" class="text-danger" />
                </div>
              </div>

              <!-- Mandature -->
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Mandatures <span class="text-danger">*</span>
                  </label>
                  <Field name="mandatures" v-slot="{ field }">
                    <Multiselect
                      :options="mandaturesOptions" :searchable="true" :multiple="false"
                      track-by="label" label="label"
                      v-model="formData.mandature" v-bind="field"
                      placeholder="Sélectionner la mandature"
                    />
                  </Field>
                  <ErrorMessage name="mandatures" class="text-danger" />
                </div>
              </div>

              <!-- Poste -->
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Postes <span class="text-danger">*</span>
                  </label>
                  <Field name="postes" v-slot="{ field }">
                    <Multiselect
                      :options="PosteSelected" :searchable="true" :multiple="false"
                      track-by="label" label="label"
                      v-model="formData.poste" v-bind="field"
                      placeholder="Sélectionner un poste"
                    />
                  </Field>
                  <ErrorMessage name="postes" class="text-danger" />
                </div>
              </div>

              <!-- Membre dropdown -->
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <div class="d-flex justify-content-between align-items-center mb-10">
                    <label class="d-block text-black fw-semibold mb-0">
                      Membres <span class="text-danger">*</span>
                    </label>
                    <button type="button" class="btn btn-sm btn-warning" style="color:white;font-size:10px;"
                      data-bs-toggle="modal" data-bs-target="#addMembreModal">
                      Ajouter +
                    </button>
                  </div>
                  <Field name="membre" v-slot="{ field }">
                    <Multiselect
                      :options="membresOptions" :searchable="true" :multiple="false"
                      track-by="value" label="label"
                      v-model="formData.membre" v-bind="field"
                      placeholder="Sélectionner un membre"
                      @change="onMembreChange"
                    />
                  </Field>
                  <ErrorMessage name="membre" class="text-danger" />
                </div>
              </div>

              <!-- ══ BLOC ÉDITION MEMBRE ══ -->
              <template v-if="formData.membre">
                <div class="col-12 mb-10">
                  <div class="membre-edit-block p-15 rounded-2">
                    <p class="fw-semibold text-success mb-15" style="font-size:13px;">
                      <i class="las la-user-edit me-1"></i>
                      Modifier les informations du membre sélectionné
                    </p>
                    <div class="row">

                      <!-- Nom -->
                      <div class="col-md-4 mb-15">
                        <label class="d-block text-black fw-semibold mb-10" style="font-size:13px;">Nom</label>
                        <input type="text" class="form-control" v-model="membreEditable.nom" placeholder="Nom" />
                      </div>

                      <!-- Prénom -->
                      <div class="col-md-4 mb-15">
                        <label class="d-block text-black fw-semibold mb-10" style="font-size:13px;">Prénom</label>
                        <input type="text" class="form-control" v-model="membreEditable.prenom" placeholder="Prénom" />
                      </div>

                      <!-- Photo -->
                      <div class="col-md-4 mb-15">
                        <label class="d-block text-black fw-semibold mb-10" style="font-size:13px;">Photo</label>

                        <!-- Aperçu photo actuelle -->
                        <div v-if="membreEditable.urlImageActuelle && !membreEditable.nouvellePhotoPreview" class="mb-10">
                          <img
                            :src="getImageUrl(membreEditable.urlImageActuelle)"
                            alt="Photo actuelle"
                            style="width:70px;height:70px;object-fit:cover;object-position:top;border-radius:8px;border:2px solid #009f3c;"
                          />
                          <span style="font-size:11px;color:#6b7280;" class="ms-2">Photo actuelle</span>
                        </div>

                        <!-- Aperçu nouvelle photo -->
                        <div v-if="membreEditable.nouvellePhotoPreview" class="mb-10">
                          <img
                            :src="membreEditable.nouvellePhotoPreview"
                            alt="Nouvelle photo"
                            style="width:70px;height:70px;object-fit:cover;object-position:top;border-radius:8px;border:2px solid #0984e3;"
                          />
                          <span style="font-size:11px;color:#0984e3;" class="ms-2">Nouvelle photo</span>
                        </div>

                        <input
                          type="file"
                          class="form-control"
                          accept="image/*"
                          ref="photoInput"
                          @change="onPhotoMembreChange"
                        />
                      </div>

                    </div>
                  </div>
                </div>
              </template>

            </div>
          </div>
        </div>

        <!-- Boutons -->
        <div class="row mt-10">
          <div class="col-md-12">
            <div class="d-flex align-items-center">
              <button
                class="default-btn me-20 transition border-0 fw-medium text-white
                  pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35
                  rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit"
                :disabled="isSubmitting"
              >
                <span v-if="isSubmitting">En cours...</span>
                <span v-else>Modifier</span>
              </button>
              <router-link to="/liste-assignation" class="btn btn-danger transition border-0 lh-1 fw-medium">
                <i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                Annuler
              </router-link>
            </div>
          </div>
        </div>

      </Form>
    </div>

    <!-- ══ MODAL AJOUT NOUVEAU MEMBRE ══ -->
    <div class="modal fade" id="addMembreModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" style="max-width:600px;">
        <div class="modal-content">
          <div class="modal-header justify-content-center border-0">
            <h5 class="modal-title" style="text-decoration:underline;">Ajouter un nouveau membre</h5>
          </div>
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col-md-8 mb-3">
                <label class="form-label">Nom :</label>
                <input type="text" class="form-control" v-model="newMembre.nom" placeholder="Entrez le nom" />
              </div>
              <div class="col-md-8 mb-3">
                <label class="form-label">Prénom :</label>
                <input type="text" class="form-control" v-model="newMembre.prenom" placeholder="Entrez le prénom" />
              </div>
              <div class="col-md-8 mb-3">
                <label class="form-label">Image :</label>
                <input type="file" class="form-control" @change="onNewImageChange" />
              </div>
            </div>
            <div class="modal-footer justify-content-center">
              <button type="button" class="btn btn-primary" @click="addNewMembre">Ajouter</button>
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, onMounted, nextTick } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import Multiselect from "@vueform/multiselect";
import { useRoute, useRouter } from "vue-router";
import ApiService from "../../services/ApiService";
import { success, error } from "../../utils/utils";
import { PostMembreMandature, Membre, Mandature, Postes } from "@/models/postemembremandature";
import { Organes } from "@/models/Postes";
import Swal from "sweetalert2";
import { Modal } from "bootstrap";

export default defineComponent({
  name: "EditAssignation",
  components: { Form, Field, ErrorMessage, Multiselect },
  setup() {
    const router = useRouter();
    const route  = useRoute();
    const postemembremandatureId = Number(route.params.id);
    const isSubmitting = ref(false);
    const photoInput   = ref<HTMLInputElement | null>(null);

    const PmmSchema = Yup.object().shape({});

    const organesOptions    = ref<{ value: number; label: string; postes: Postes[] }[]>([]);
    const mandaturesOptions = ref<{ value: number; label: string }[]>([]);
    const membresOptions    = ref<{ value: number; label: string; nom: string; prenom: string; urlImage?: string }[]>([]);
    const PosteSelected     = ref<{ value: number; label: string }[]>([]);

    const formData = reactive({
      organe:    null as number | null,
      poste:     null as number | null,
      membre:    null as number | null,
      mandature: null as number | null,
    });

    const membreEditable = reactive({
      nom:                  "" as string,
      prenom:               "" as string,
      urlImageActuelle:     "" as string,
      nouvellePhoto:        null as File | null,
      nouvellePhotoPreview: "" as string,
    });

    const newMembre = reactive({
      nom: "", prenom: "", urlImage: null as File | null,
    });

    // ── Sélection d'un membre → pré-remplissage ──
    const onMembreChange = (membreId: number) => {
      const found = membresOptions.value.find(m => m.value === membreId);
      if (found) {
        membreEditable.nom               = found.nom    ?? "";
        membreEditable.prenom            = found.prenom ?? "";
        membreEditable.urlImageActuelle  = found.urlImage ?? "";
        membreEditable.nouvellePhoto     = null;
        membreEditable.nouvellePhotoPreview = "";
      }
    };

    // ── Changement de photo ──
    const onPhotoMembreChange = (event: Event) => {
      const target = event.target as HTMLInputElement;
      if (target.files && target.files.length > 0) {
        const file = target.files[0];
        // Vérification type et taille (max 5 Mo)
        if (!file.type.startsWith("image/")) {
          Swal.fire({ title: "Fichier invalide", text: "Veuillez sélectionner une image.", icon: "error" });
          return;
        }
        if (file.size > 5 * 1024 * 1024) {
          Swal.fire({ title: "Fichier trop volumineux", text: "La photo ne doit pas dépasser 5 Mo.", icon: "error" });
          return;
        }
        membreEditable.nouvellePhoto        = file;
        membreEditable.nouvellePhotoPreview = URL.createObjectURL(file);
      } else {
        membreEditable.nouvellePhoto        = null;
        membreEditable.nouvellePhotoPreview = "";
      }
    };

    // ── Chargements API ──
    const fetchOrganes = async () => {
      try {
        const res = await ApiService.get("/organes?limit=0");
        organesOptions.value = res.data.data.data.map((o: Organes) => ({
          value: o.id, label: o.nom, postes: o.postes || [],
        }));
      } catch { error("Erreur chargement organes"); }
    };

    const fetchMandatures = async () => {
      try {
        const res = await ApiService.get("/mandature");
        mandaturesOptions.value = res.data.data.data.map((m: Mandature) => ({
          value: m.id, label: m.libelle,
        }));
      } catch { error("Erreur chargement mandatures"); }
    };

    const fetchMembres = async () => {
      try {
        const res = await ApiService.get("/membre");
        membresOptions.value = res.data.map((m: Membre) => ({
          value:    m.id,
          label:    `${m.nom} ${m.prenom}`,
          nom:      m.nom,
          prenom:   m.prenom,
          urlImage: m.urlImage ?? "",
        }));
      } catch { error("Erreur chargement membres"); }
    };

    const fetchPmm = async () => {
      try {
        const { data } = await ApiService.get(`/pmm/${postemembremandatureId}`);
        const pmm: PostMembreMandature = data.data;

        const organe = organesOptions.value.find(o =>
          o.postes.some(p => p.id === pmm.poste.id)
        );
        if (organe) {
          formData.organe = organe.value;
          PosteSelected.value = organe.postes.map((p: Postes) => ({
            value: p.id, label: p.nomPoste,
          }));
          await nextTick();
          formData.poste = pmm.poste.id;
        }

        formData.mandature = pmm.mandature.id;
        formData.membre    = pmm.membre.id;
        onMembreChange(pmm.membre.id);

      } catch { error("Erreur chargement assignation"); }
    };

    const onOrganeChange = (organeId: number) => {
      const selected = organesOptions.value.find(o => o.value === organeId);
      formData.organe = organeId;
      formData.poste  = null;
      PosteSelected.value = selected
        ? selected.postes.map((p: Postes) => ({ value: p.id, label: p.nomPoste }))
        : [];
    };

    // ── Modal nouveau membre ──
    const onNewImageChange = (e: Event) => {
      const t = e.target as HTMLInputElement;
      newMembre.urlImage = t.files?.length ? t.files[0] : null;
    };

    const addNewMembre = () => {
      if (!newMembre.nom || !newMembre.prenom) {
        Swal.fire({ title: "Remplissez les champs", icon: "error", timer: 1500 });
        return;
      }
      const tmp = {
        value:    Date.now() * -1,
        label:    `${newMembre.nom} ${newMembre.prenom}`,
        nom:      newMembre.nom,
        prenom:   newMembre.prenom,
        urlImage: "",
      };
      membresOptions.value.push(tmp);
      formData.membre              = tmp.value;
      membreEditable.nom           = newMembre.nom;
      membreEditable.prenom        = newMembre.prenom;
      membreEditable.urlImageActuelle     = "";
      membreEditable.nouvellePhoto        = newMembre.urlImage;
      membreEditable.nouvellePhotoPreview = newMembre.urlImage
        ? URL.createObjectURL(newMembre.urlImage) : "";

      const el = document.getElementById("addMembreModal");
      if (el) (Modal.getInstance(el) || new Modal(el)).hide();
      Swal.fire({ title: "Membre ajouté", icon: "success", timer: 1500 });
    };
    
    const EditPmm = async () => {
      isSubmitting.value = true;
      try {

        if (formData.membre && formData.membre > 0) {

          if (membreEditable.nouvellePhoto) {
            // Envoi multipart avec la photo
            const fd = new FormData();
            fd.append("nom",      membreEditable.nom.trim());
            fd.append("prenom",   membreEditable.prenom.trim());
            fd.append("urlImage", membreEditable.nouvellePhoto, membreEditable.nouvellePhoto.name);

            await ApiService.vueInstance.axios.put(
              `${ApiService.vueInstance.axios.defaults.baseURL}/membre/${formData.membre}`,
              fd,
              { headers: { "Content-Type": "multipart/form-data" } }  // ← forcé explicitement
            );
          } else {
            // Envoi JSON simple (pas de fichier)
            await ApiService.put(`/membre/${formData.membre}`, {
              nom:    membreEditable.nom.trim(),
              prenom: membreEditable.prenom.trim(),
            });
          }

          // 1b. Mise à jour de l'assignation
          await ApiService.put(`/pmm/${postemembremandatureId}`, {
            posteId:     formData.poste,
            mandatureId: formData.mandature,
            membreId:    formData.membre,
          });

        } else {
          const fd = new FormData();
          fd.append("nom",    membreEditable.nom.trim());
          fd.append("prenom", membreEditable.prenom.trim());
          if (membreEditable.nouvellePhoto) {
            fd.append("urlImage", membreEditable.nouvellePhoto, membreEditable.nouvellePhoto.name);
          }

          await ApiService.vueInstance.axios.put(
            `${ApiService.vueInstance.axios.defaults.baseURL}/pmm/${postemembremandatureId}`,
            fd,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
        }

        Swal.fire({ title: "Modification effectuée avec succès", icon: "success" });
        router.push("/liste-assignation");

      } catch (err: any) {
        console.error("Erreur modification :", err?.response?.data ?? err);
        Swal.fire({
          title: "Erreur lors de la modification",
          // Affiche le message précis du serveur si disponible
          text: err?.response?.data?.message ?? err?.message ?? "Erreur inconnue",
          icon: "error",
        });
      } finally {
        isSubmitting.value = false;
      }
    };

    function getImageUrl(filename?: string): string {
      if (!filename) return "";
      return `${ApiService.vueInstance.axios.defaults["updateUrl"]}uploads/membres/${filename}`;
    }

    onMounted(async () => {
      await Promise.all([fetchOrganes(), fetchMandatures(), fetchMembres()]);
      await fetchPmm();
    });

    return {
      PmmSchema, organesOptions, mandaturesOptions, membresOptions,
      PosteSelected, formData, membreEditable, newMembre,
      isSubmitting, photoInput,
      EditPmm, onOrganeChange, onMembreChange,
      onPhotoMembreChange, onNewImageChange, addNewMembre, getImageUrl,
    };
  },
});
</script>

<style scoped>
.membre-edit-block {
  background: #f0faf4;
  border: 1px solid #c3e6cb;
}
</style>